import { useMemo } from 'react';

export const useTimezone = () => {
  return useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);
};
